module.exports = __webpack_public_path__ + "static/fonts/Robotolightitalic.692f993.woff";